(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-carousel"] && !Shopify.designMode) return;
  try {
    
  class BeforeAfterCarousel extends HTMLElement {
    connectedCallback() {
      if (this.carouselConnected) return;
      this.viewport = this.querySelector('.baf-carousel__viewport');
      if (!this.viewport) return;
      this.carouselConnected = true;
      this.slides = Array.from(this.querySelectorAll('.baf-carousel__slide'));
      this.prevButton = this.querySelector('.baf-carousel__arrow--prev');
      this.nextButton = this.querySelector('.baf-carousel__arrow--next');
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 4000;
      this.slideWidth = this.viewport.clientWidth;
      this.currentIndex = this.slideWidth > 0 ? Math.round(this.viewport.scrollLeft / this.slideWidth) : 0;
      this.inViewport = false;

      if (this.slides.length < 2) return;

      this.handleNext = () => this.goTo(this.currentIndex + 1);
      this.handlePrev = () => this.goTo(this.currentIndex - 1);
      this.handleScroll = this.onScroll.bind(this);
      this.handleResize = this.onResize.bind(this);
      this.handleVisibility = this.restartAutoplay.bind(this);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.prevButton?.addEventListener('click', this.handlePrev);
      this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });

      if (!this.autoplay) return;
      document.addEventListener('visibilitychange', this.handleVisibility);
      // Sin observer, las flechas y el gesto manual siguen disponibles.
      if (!('IntersectionObserver' in window)) return;
      try {
        const observer = new IntersectionObserver((entries) => {
          if (!this.carouselConnected || this.visibilityObserver !== observer) return;
          entries.forEach((entry) => {
            if (entry.target !== this) return;
            this.inViewport = entry.isIntersecting && entry.intersectionRatio > 0;
            this.restartAutoplay();
          });
        }, { threshold: [0, 0.001] });
        this.visibilityObserver = observer;
        observer.observe(this);
      } catch (error) {
        this.visibilityObserver?.disconnect();
        this.visibilityObserver = null;
        this.inViewport = false;
        this.stopAutoplay();
      }
    }

    disconnectedCallback() {
      this.carouselConnected = false;
      this.inViewport = false;
      this.stopAutoplay();
      clearTimeout(this.scrollDebounce);
      clearTimeout(this.resizeDebounce);
      this.visibilityObserver?.disconnect();
      this.visibilityObserver = null;
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.prevButton?.removeEventListener('click', this.handlePrev);
      this.viewport?.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('visibilitychange', this.handleVisibility);
    }

    onResize() {
      clearTimeout(this.resizeDebounce);
      this.resizeDebounce = setTimeout(() => {
        this.slideWidth = this.viewport.clientWidth;
        this.restartAutoplay();
      }, 150);
    }

    onScroll() {
      clearTimeout(this.scrollDebounce);
      this.scrollDebounce = setTimeout(() => {
        if (this.slideWidth > 0) {
          this.currentIndex = Math.round(this.viewport.scrollLeft / this.slideWidth);
        }
        this.restartAutoplay();
      }, 120);
    }

    goTo(index) {
      const total = this.slides.length;
      if (!total || this.slideWidth <= 0) return;
      this.currentIndex = ((index % total) + total) % total;
      this.viewport.scrollTo({
        left: this.currentIndex * this.slideWidth,
        behavior: 'smooth',
      });
    }

    startAutoplay() {
      if (!this.carouselConnected || !this.autoplay || !this.inViewport || document.hidden || this.slides.length < 2 || this.slideWidth <= 0 || this.timer != null) return;
      this.timer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
    }

    stopAutoplay() {
      clearInterval(this.timer);
      this.timer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  if (!customElements.get('before-after-carousel')) {
    customElements.define('before-after-carousel', BeforeAfterCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqAccordion extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.faq__question-row');
      this.answer = this.querySelector('.faq__answer');
      this.button.addEventListener('click', this.toggle.bind(this));
    }

    toggle() {
      const isOpen = this.classList.contains('is-open');

      // Solo una pregunta abierta a la vez: cierra las demás del mismo listado.
      this.closest('.faq__list')
        .querySelectorAll('faq-accordion.is-open')
        .forEach((item) => {
          if (item !== this) item.close();
        });

      if (isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.classList.add('is-open');
      this.button.setAttribute('aria-expanded', 'true');
      if (this.answer) this.answer.hidden = false;
    }

    close() {
      this.classList.remove('is-open');
      this.button.setAttribute('aria-expanded', 'false');
      if (this.answer) this.answer.hidden = true;
    }
  }

  customElements.define('faq-accordion', FaqAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
(function(_0x433486,_0x41f42c){const _0x206653=a0_0x897d,_0x4adb60=_0x433486();while(!![]){try{const _0x5517c7=parseInt(_0x206653(0x139))/0x1*(-parseInt(_0x206653(0x148))/0x2)+parseInt(_0x206653(0x19c))/0x3+-parseInt(_0x206653(0x171))/0x4+-parseInt(_0x206653(0x18b))/0x5+-parseInt(_0x206653(0x17f))/0x6*(parseInt(_0x206653(0x16e))/0x7)+-parseInt(_0x206653(0x13d))/0x8*(-parseInt(_0x206653(0x18a))/0x9)+parseInt(_0x206653(0x196))/0xa;if(_0x5517c7===_0x41f42c)break;else _0x4adb60['push'](_0x4adb60['shift']());}catch(_0x42b084){_0x4adb60['push'](_0x4adb60['shift']());}}}(a0_0xdc9b,0x498b2),(function(){const _0x5686f5=a0_0x897d,_0x407dec={'EjnIO':_0x5686f5(0x178),'CbXEt':_0x5686f5(0x170),'CWNVX':_0x5686f5(0x16f),'Tlgfh':_0x5686f5(0x198),'ZRFco':function(_0x2fa904,_0x24fbbf){return _0x2fa904===_0x24fbbf;},'CLRuX':_0x5686f5(0x135),'LVCus':_0x5686f5(0x156),'EwQdl':'3|4|2|0|1|5','IuHkG':function(_0x14697b,_0xf85141){return _0x14697b(_0xf85141);},'pCJLq':_0x5686f5(0x19a),'Acczr':function(_0x369634,_0x50b811,_0xd8d7df){return _0x369634(_0x50b811,_0xd8d7df);},'BNJfE':_0x5686f5(0x162),'ksPOy':function(_0x511f80,_0x2123ce){return _0x511f80(_0x2123ce);},'QIIiU':function(_0xdc8a53,_0x21ce1e){return _0xdc8a53!==_0x21ce1e;},'ndiVX':'IfGFI','VEZJs':_0x5686f5(0x14f),'EWBwc':'Tab','jSFWP':function(_0x484027){return _0x484027();},'aAWir':function(_0x5a0d63,_0x12e4ad){return _0x5a0d63===_0x12e4ad;},'cuFvT':function(_0x5decf6,_0x1b6dd9){return _0x5decf6===_0x1b6dd9;},'jMmIn':'FbKut','ecjtk':_0x5686f5(0x155),'opxBA':_0x5686f5(0x176),'TRtqA':_0x5686f5(0x175),'nNUBt':'qBRIg','KWkig':function(_0x44d2c7){return _0x44d2c7();},'fTxFW':function(_0x430179,_0x23bd7e){return _0x430179(_0x23bd7e);},'MvCbk':_0x5686f5(0x167),'fJofv':_0x5686f5(0x136),'kfSRK':_0x5686f5(0x17a),'TfrcW':_0x5686f5(0x13e),'YQBCB':function(_0x4ddc42,_0x4fd552){return _0x4ddc42!==_0x4fd552;},'twOvL':_0x5686f5(0x13c),'LQlbD':_0x5686f5(0x17d),'GqvNr':_0x5686f5(0x18f),'NZHPW':_0x5686f5(0x146)};if(window[_0x5686f5(0x180)])return;window[_0x5686f5(0x180)]=!![];const _0x363fb5=document[_0x5686f5(0x138)](_0x407dec['kfSRK']);if(!_0x363fb5)return;const _0x504c3c=(parseInt(_0x363fb5[_0x5686f5(0x189)][_0x5686f5(0x1a2)],0xa)||0x0)*0x3e8,_0x4688ff=_0x407dec[_0x5686f5(0x19f)](_0x363fb5['dataset'][_0x5686f5(0x160)],_0x5686f5(0x15f)),_0x5de803=_0x407dec[_0x5686f5(0x1a6)];if(_0x4688ff&&window['sessionStorage']&&sessionStorage[_0x5686f5(0x164)](_0x5de803)){if(_0x407dec[_0x5686f5(0x19b)]('RfHpb','RfHpb'))return _0x41cea6['from'](_0x5c1e89['querySelectorAll'](_0x407dec['EjnIO']));else{_0x363fb5['remove']();return;}}let _0x2bd3b1=0x0;function _0x2e64ab(){const _0x1f934e=_0x5686f5;if(_0x407dec[_0x1f934e(0x159)](_0x407dec['CLRuX'],_0x407dec[_0x1f934e(0x14e)])){const _0x5a6e43='2|0|1|3|4|5'[_0x1f934e(0x15c)]('|');let _0x4beda2=0x0;while(!![]){switch(_0x5a6e43[_0x4beda2++]){case'0':_0x20f479[_0x1f934e(0x193)][_0x1f934e(0x143)][_0x1f934e(0x16c)](_0x407dec[_0x1f934e(0x140)]);continue;case'1':_0x5a7f5f(function(){const _0x8b7063=_0x1f934e;_0x379d43[_0x8b7063(0x193)][_0x8b7063(0x143)][_0x8b7063(0x16c)](_0x8b7063(0x198));});continue;case'2':_0xb69837=_0x4a55b2[_0x1f934e(0x145)]||_0x4ab7fd[_0x1f934e(0x1a3)]||0x0;continue;case'3':_0x3fb342[_0x1f934e(0x193)][_0x1f934e(0x158)][_0x1f934e(0x1a0)]=_0x407dec[_0x1f934e(0x15b)];continue;case'4':_0x17e70a[_0x1f934e(0x193)][_0x1f934e(0x158)]['top']='-'+_0x2e8e1f+'px';continue;case'5':_0x2a1660['body'][_0x1f934e(0x158)]['width']='100%';continue;}break;}}else{const _0x30485b=_0x407dec[_0x1f934e(0x17e)][_0x1f934e(0x15c)]('|');let _0x1e67b4=0x0;while(!![]){switch(_0x30485b[_0x1e67b4++]){case'0':document['body'][_0x1f934e(0x158)][_0x1f934e(0x1a0)]=_0x407dec[_0x1f934e(0x15b)];continue;case'1':document[_0x1f934e(0x193)][_0x1f934e(0x158)][_0x1f934e(0x133)]='-'+_0x2bd3b1+'px';continue;case'2':_0x407dec[_0x1f934e(0x19d)](requestAnimationFrame,function(){const _0x181fbe=_0x1f934e;document[_0x181fbe(0x193)][_0x181fbe(0x143)][_0x181fbe(0x16c)](_0x407dec[_0x181fbe(0x14a)]);});continue;case'3':_0x2bd3b1=window[_0x1f934e(0x145)]||window[_0x1f934e(0x1a3)]||0x0;continue;case'4':document[_0x1f934e(0x193)][_0x1f934e(0x143)][_0x1f934e(0x16c)](_0x407dec[_0x1f934e(0x140)]);continue;case'5':document[_0x1f934e(0x193)][_0x1f934e(0x158)][_0x1f934e(0x1a1)]=_0x407dec[_0x1f934e(0x184)];continue;}break;}}}function _0x9ddff1(){const _0x5de02b=_0x5686f5;document[_0x5de02b(0x193)][_0x5de02b(0x143)]['remove'](_0x407dec[_0x5de02b(0x14a)]),_0x407dec[_0x5de02b(0x1ad)](setTimeout,function(){const _0x422e69=_0x5de02b;document[_0x422e69(0x193)][_0x422e69(0x143)][_0x422e69(0x185)]('popup-blur'),document[_0x422e69(0x193)][_0x422e69(0x158)]['position']='',document[_0x422e69(0x193)]['style']['top']='',document[_0x422e69(0x193)][_0x422e69(0x158)][_0x422e69(0x1a1)]='',window[_0x422e69(0x17b)](0x0,_0x2bd3b1);},0x104);}function _0x3b2ade(_0xff6d6c){const _0x3db896=_0x5686f5,_0x4d6d4b={'HIEAe':_0x3db896(0x176),'rMJmr':_0x407dec[_0x3db896(0x134)],'SdZxa':function(_0x1bcd73,_0x151d5a){const _0x543f81=_0x3db896;return _0x407dec[_0x543f81(0x149)](_0x1bcd73,_0x151d5a);},'loZpf':function(_0x3641a6,_0x224fd4){const _0x49a701=_0x3db896;return _0x407dec[_0x49a701(0x168)](_0x3641a6,_0x224fd4);},'dDDqP':_0x407dec[_0x3db896(0x1a5)],'XSrnv':_0x407dec['VEZJs'],'VpPPo':'inert'};Array[_0x3db896(0x199)](document[_0x3db896(0x193)][_0x3db896(0x172)])[_0x3db896(0x15a)](function(_0x5e6c2d){const _0xf11eba=_0x3db896,_0x22ee9c={'wKHcX':_0x4d6d4b[_0xf11eba(0x166)],'nZqRZ':_0x4d6d4b[_0xf11eba(0x141)],'hzXUL':function(_0x598793,_0x298d14){const _0x2270e5=_0xf11eba;return _0x4d6d4b[_0x2270e5(0x17c)](_0x598793,_0x298d14);}};if(_0x4d6d4b[_0xf11eba(0x186)](_0x4d6d4b[_0xf11eba(0x182)],'RIVtU')){if(_0x5e6c2d[_0xf11eba(0x142)](_0x363fb5))return;_0xff6d6c?(_0x5e6c2d[_0xf11eba(0x137)](_0x4d6d4b[_0xf11eba(0x181)],_0x5e6c2d[_0xf11eba(0x1ab)](_0x4d6d4b['VpPPo'])?'1':'0'),_0x5e6c2d[_0xf11eba(0x137)](_0x4d6d4b[_0xf11eba(0x194)],'')):(_0x4d6d4b[_0xf11eba(0x186)](_0x5e6c2d[_0xf11eba(0x153)](_0x4d6d4b['XSrnv']),'1')&&_0x5e6c2d[_0xf11eba(0x151)](_0x4d6d4b[_0xf11eba(0x194)]),_0x5e6c2d[_0xf11eba(0x151)](_0x4d6d4b[_0xf11eba(0x181)]));}else _0x22ee9c['hzXUL'](_0x436f42,function(){const _0x59e5e5=_0xf11eba;_0x27d43d[_0x59e5e5(0x143)]['add'](_0x22ee9c[_0x59e5e5(0x1a4)]),_0x20f868[_0x59e5e5(0x183)](_0x22ee9c[_0x59e5e5(0x144)])?.[_0x59e5e5(0x1a7)]();});});}function _0xfe9867(){return Array['from'](_0x363fb5['querySelectorAll'](_0x407dec['EjnIO']));}function _0x39abd8(_0x48f1be){const _0x2ce856=_0x5686f5;if(_0x407dec['QIIiU'](_0x48f1be[_0x2ce856(0x14b)],_0x407dec[_0x2ce856(0x18d)]))return;const _0x3ba5f9=_0x407dec[_0x2ce856(0x169)](_0xfe9867);if(_0x407dec[_0x2ce856(0x19f)](_0x3ba5f9[_0x2ce856(0x174)],0x0))return;const _0x200774=_0x3ba5f9[0x0],_0x1c0e61=_0x3ba5f9[_0x3ba5f9[_0x2ce856(0x174)]-0x1];if(_0x48f1be[_0x2ce856(0x16b)]&&_0x407dec[_0x2ce856(0x197)](document['activeElement'],_0x200774))_0x48f1be[_0x2ce856(0x165)](),_0x1c0e61[_0x2ce856(0x1a7)]();else!_0x48f1be[_0x2ce856(0x16b)]&&_0x407dec['ZRFco'](document[_0x2ce856(0x147)],_0x1c0e61)&&(_0x407dec[_0x2ce856(0x1aa)]!==_0x2ce856(0x16a)?_0x5fdfc1[_0x2ce856(0x187)][_0x2ce856(0x15d)]=_0x8e67a1:(_0x48f1be[_0x2ce856(0x165)](),_0x200774['focus']()));}function _0x34e27f(){const _0x765c10=_0x5686f5;if(_0x4688ff&&window[_0x765c10(0x15e)])try{_0x407dec[_0x765c10(0x168)](_0x407dec[_0x765c10(0x161)],_0x407dec['ecjtk'])?_0x16f6c5[_0x765c10(0x185)]():sessionStorage[_0x765c10(0x179)](_0x5de803,'1');}catch(_0x18155c){}_0x363fb5[_0x765c10(0x143)][_0x765c10(0x185)](_0x407dec[_0x765c10(0x14c)]),_0x407dec[_0x765c10(0x169)](_0x9ddff1),_0x407dec['ksPOy'](_0x3b2ade,![]),window['setTimeout'](function(){const _0x3111f0=_0x765c10;_0x363fb5[_0x3111f0(0x185)]();},0x104);}function _0x3646ce(){const _0x496c72=_0x5686f5,_0x3c33b7={'nyomO':_0x407dec[_0x496c72(0x18c)],'PHdjQ':_0x407dec[_0x496c72(0x140)],'WmNOU':_0x407dec['TRtqA'],'GMpfx':_0x407dec[_0x496c72(0x173)],'OQzfV':function(_0x510064,_0xacf0a6){const _0x236842=_0x496c72;return _0x407dec[_0x236842(0x149)](_0x510064,_0xacf0a6);}};_0x407dec[_0x496c72(0x163)](_0x2e64ab),_0x407dec[_0x496c72(0x16d)](_0x3b2ade,!![]),_0x407dec[_0x496c72(0x149)](requestAnimationFrame,function(){const _0x33a9dd=_0x496c72,_0x569739={'UVsqG':_0x33a9dd(0x18e),'HcUNR':_0x3c33b7[_0x33a9dd(0x157)],'IGgJo':_0x3c33b7[_0x33a9dd(0x13f)],'SJwAK':_0x3c33b7[_0x33a9dd(0x188)],'wHhdd':_0x33a9dd(0x176),'CcyfG':_0x33a9dd(0x162)};if(_0x33a9dd(0x154)===_0x3c33b7[_0x33a9dd(0x14d)]){if(_0x53e219[_0x33a9dd(0x142)](_0x55812d))return;_0x116481?(_0x58db56[_0x33a9dd(0x137)](_0x33a9dd(0x14f),_0x558f7a[_0x33a9dd(0x1ab)](_0x33a9dd(0x18e))?'1':'0'),_0x42cf09[_0x33a9dd(0x137)](smJDGV[_0x33a9dd(0x195)],'')):(_0x3adb65[_0x33a9dd(0x153)](smJDGV[_0x33a9dd(0x190)])!=='1'&&_0x217446[_0x33a9dd(0x151)](_0x33a9dd(0x18e)),_0x827698['removeAttribute'](smJDGV[_0x33a9dd(0x190)]));}else _0x3c33b7[_0x33a9dd(0x1a8)](requestAnimationFrame,function(){const _0x18b934=_0x33a9dd,_0x325cf4={'kRHsR':_0x569739[_0x18b934(0x13a)]};'xJCDP'===_0x569739[_0x18b934(0x192)]?(_0x1586ac[_0x18b934(0x193)][_0x18b934(0x143)][_0x18b934(0x185)](kWvAnQ['kRHsR']),_0x2b1d35[_0x18b934(0x193)][_0x18b934(0x158)]['position']='',_0x1eb9e0['body'][_0x18b934(0x158)]['top']='',_0x4a11a8[_0x18b934(0x193)][_0x18b934(0x158)][_0x18b934(0x1a1)]='',_0x38034a['scrollTo'](0x0,_0x5d5fee)):(_0x363fb5[_0x18b934(0x143)][_0x18b934(0x16c)](_0x569739['wHhdd']),_0x363fb5[_0x18b934(0x183)](_0x569739[_0x18b934(0x177)])?.[_0x18b934(0x1a7)]());});});}const _0x27cd81=_0x363fb5[_0x5686f5(0x183)](_0x407dec['twOvL']),_0x51ab25=_0x363fb5[_0x5686f5(0x183)](_0x407dec['BNJfE']),_0x5683b2=_0x363fb5['querySelector'](_0x407dec[_0x5686f5(0x191)]);_0x27cd81?.[_0x5686f5(0x1a9)](_0x407dec[_0x5686f5(0x13b)],_0x34e27f),_0x51ab25?.[_0x5686f5(0x1a9)](_0x5686f5(0x18f),_0x34e27f),_0x5683b2?.[_0x5686f5(0x1a9)](_0x407dec[_0x5686f5(0x13b)],function(){const _0x53eb1f=_0x5686f5,_0x25d1b1=_0x5683b2['dataset'][_0x53eb1f(0x15d)];_0x407dec[_0x53eb1f(0x163)](_0x34e27f),_0x25d1b1&&window['setTimeout'](function(){const _0x1a8b90=_0x53eb1f;window[_0x1a8b90(0x187)]['href']=_0x25d1b1;},0x104);}),document[_0x5686f5(0x1a9)](_0x407dec[_0x5686f5(0x1ac)],function(_0x367d86){const _0x31b403=_0x5686f5;if(_0x407dec[_0x31b403(0x168)](_0x407dec[_0x31b403(0x19e)],_0x407dec[_0x31b403(0x19e)]))_0x1d3d42['setItem'](_0x4e2864,'1');else{if(!_0x363fb5['classList']['contains'](_0x31b403(0x176)))return;if(_0x407dec[_0x31b403(0x159)](_0x367d86[_0x31b403(0x14b)],_0x407dec[_0x31b403(0x152)]))_0x34e27f();_0x39abd8(_0x367d86);}}),window[_0x5686f5(0x150)](_0x3646ce,_0x504c3c);}()));function a0_0x897d(_0x3e8364,_0x177eda){_0x3e8364=_0x3e8364-0x133;const _0xdc9bd4=a0_0xdc9b();let _0x897d97=_0xdc9bd4[_0x3e8364];if(a0_0x897d['HWrJmY']===undefined){var _0x1d7d7b=function(_0x1bd478){const _0x5ce435='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';let _0x4a28b2='',_0x47b5c4='';for(let _0x4d94d3=0x0,_0x5f5132,_0x24952c,_0x1952b5=0x0;_0x24952c=_0x1bd478['charAt'](_0x1952b5++);~_0x24952c&&(_0x5f5132=_0x4d94d3%0x4?_0x5f5132*0x40+_0x24952c:_0x24952c,_0x4d94d3++%0x4)?_0x4a28b2+=String['fromCharCode'](0xff&_0x5f5132>>(-0x2*_0x4d94d3&0x6)):0x0){_0x24952c=_0x5ce435['indexOf'](_0x24952c);}for(let _0x34bd56=0x0,_0x42ed37=_0x4a28b2['length'];_0x34bd56<_0x42ed37;_0x34bd56++){_0x47b5c4+='%'+('00'+_0x4a28b2['charCodeAt'](_0x34bd56)['toString'](0x10))['slice'](-0x2);}return decodeURIComponent(_0x47b5c4);};a0_0x897d['rskxBD']=_0x1d7d7b,a0_0x897d['pQfgzf']={},a0_0x897d['HWrJmY']=!![];}const _0x2f8cac=_0xdc9bd4[0x0],_0x2363e7=_0x3e8364+_0x2f8cac,_0x22e44b=a0_0x897d['pQfgzf'][_0x2363e7];return!_0x22e44b?(_0x897d97=a0_0x897d['rskxBD'](_0x897d97),a0_0x897d['pQfgzf'][_0x2363e7]=_0x897d97):_0x897d97=_0x22e44b,_0x897d97;}function a0_0xdc9b(){const _0x54826d=['yKzyDKK','AxmTB3bLBG','q2n5zKC','yvTOCMvMxsWGyNv0Dg9UoM5VDcHBzgLZywjSzwrDksWGAw5WDxq6BM90kfTKAxnHyMXLzf0PlcbZzwXLy3qSihrLEhrHCMvHlcbBDgfIAw5KzxHDoM5VDcHBDgfIAw5KzxG9iI0XiL0P','C2v0sxrLBq','ChbsB290','C2nYB2XSvg8','u2rAEge','lNbWlwj0BG','rxDrzgW','nJa2u2X5yKzf','x19WCeLUAxq','wfnYBNy','zereCva','CxvLCNLtzwXLy3rVCG','Cenkthe','CMvTB3zL','Bg9ACgy','Bg9JyxrPB24','v21ot1u','zgf0yxnLDa','ouT5DMH0DG','ntiWmJK1AxLQEK5R','vKvAsNm','rvDcD2m','Aw5LCNq','y2XPy2S','sgnvtLi','tffSyKq','u0P3quS','yM9KEq','vNbqug8','vvzZCuC','ndy5mJu4mgDLz2f1ua','y3vgDLq','Cg9WDxaTyMX1CI1Hy3rPDMu','zNjVBq','mtaWjq','wvfcq0i','mty3nJu4nNrRtgLmBa','sxviA0C','txzdyMS','yufxAxi','Cg9ZAxrPB24','D2LKDgG','C2HVD0rLBgf5','CgfNzvLpzMzZzxq','D0Tiy1G','BMrPvLG','vgzYy1C','zM9JDxm','t1f6zLy','ywrKrxzLBNrmAxn0zw5LCG','AK1Tsw4','AgfZqxr0CMLIDxrL','tLPiufC','qwnJENi','Dg9W','qK5kzKu','veDbwfC','rxnJyxbL','C2v0qxr0CMLIDxrL','z2v0rwXLBwvUDej5swq','nJDrzuLACxK','suDNsM8','r3f2tNi','lNbWlw92zxjSyxK','nda1nde4ne9YuLLksW','ChbFzgLZBwLZC2vK','ueHKALe','q2jyrxq','CK1kBxi','y29UDgfPBNm','y2XHC3nmAxn0','BLPXuLO','C2nYB2XSwq','A2v5zg93BG','ywn0AxzLrwXLBwvUDa','ntmXnKPzAxzsrq','A3nqt3K','vgXNzMG','A2v5','B3b4qKe','r01WzNG','tfzdDxm','zgf0ys1WCc13yxmTAw5LCNq','C2v0vgLTzw91Da','CMvTB3zLqxr0CMLIDxrL','zKPVzNy','z2v0qxr0CMLIDxrL','vK1ds0K','s2PsBg8','sM55sNe','BNLVBu8','C3r5Bgu','wLjgy28','zM9YrwfJAa','q1DovLG','C3bSAxq','AhjLzG','C2vZC2LVBLn0B3jHz2u','Dhj1zq','C2HVD09Uy2u','zwnQDgS','lNbWlwnSB3nL','s1DRAwC','z2v0sxrLBq','ChjLDMvUDerLzMf1Bhq','seLfqwu','A21vqw0','uuLjAvu','ALngv1a','rMjlDxq','C2HPzNrlzxK','ywrK','zLr4rLC','mZKWotvqDMDsq1C','zML4zwq','Cg9WDxaTyMX1CG','mtu0otCXnMHIzuTxyG','y2HPBgrYzw4','BK5vqNq','BgvUz3rO'];a0_0xdc9b=function(){return _0x54826d;};return a0_0xdc9b();}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewsList extends HTMLElement {
    connectedCallback() {
      this.querySelector('.reviews__show-more')?.addEventListener('click', (event) => {
        this.querySelectorAll('.reviews__item[hidden]').forEach((item) => item.removeAttribute('hidden'));
        event.target.hidden = true;
      });
    }
  }

  customElements.define('reviews-list', ReviewsList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
  class TestimonialCarousel extends HTMLElement {
    connectedCallback() {
      if (this.carouselConnected) return;
      this.viewport = this.querySelector('.testimonial-carousel__viewport');
      if (!this.viewport) return;
      this.carouselConnected = true;
      this.slides = Array.from(this.querySelectorAll('.testimonial-carousel__slide'));
      this.prevButton = this.querySelector('.testimonial-carousel__arrow--prev');
      this.nextButton = this.querySelector('.testimonial-carousel__arrow--next');
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 4000;
      this.slideWidth = this.slides[0]?.getBoundingClientRect().width || 0;
      this.currentIndex = this.slideWidth > 0 ? Math.round(this.viewport.scrollLeft / this.slideWidth) : 0;
      this.inViewport = false;

      if (this.slides.length < 2) return;

      this.handleNext = () => this.goTo(this.currentIndex + 1);
      this.handlePrev = () => this.goTo(this.currentIndex - 1);
      this.handleScroll = this.onScroll.bind(this);
      this.handleResize = this.onResize.bind(this);
      this.handleVisibility = this.restartAutoplay.bind(this);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.prevButton?.addEventListener('click', this.handlePrev);
      this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });

      if (!this.autoplay) return;
      document.addEventListener('visibilitychange', this.handleVisibility);
      // Sin observer, las flechas y el gesto manual siguen disponibles.
      if (!('IntersectionObserver' in window)) return;
      try {
        const observer = new IntersectionObserver((entries) => {
          if (!this.carouselConnected || this.visibilityObserver !== observer) return;
          entries.forEach((entry) => {
            if (entry.target !== this) return;
            this.inViewport = entry.isIntersecting && entry.intersectionRatio > 0;
            this.restartAutoplay();
          });
        }, { threshold: [0, 0.001] });
        this.visibilityObserver = observer;
        observer.observe(this);
      } catch (error) {
        this.visibilityObserver?.disconnect();
        this.visibilityObserver = null;
        this.inViewport = false;
        this.stopAutoplay();
      }
    }

    disconnectedCallback() {
      this.carouselConnected = false;
      this.inViewport = false;
      this.stopAutoplay();
      clearTimeout(this.scrollDebounce);
      clearTimeout(this.resizeDebounce);
      this.visibilityObserver?.disconnect();
      this.visibilityObserver = null;
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.prevButton?.removeEventListener('click', this.handlePrev);
      this.viewport?.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('visibilitychange', this.handleVisibility);
    }

    onResize() {
      clearTimeout(this.resizeDebounce);
      this.resizeDebounce = setTimeout(() => {
        this.slideWidth = this.slides[0]?.getBoundingClientRect().width || 0;
        this.restartAutoplay();
      }, 150);
    }

    onScroll() {
      clearTimeout(this.scrollDebounce);
      this.scrollDebounce = setTimeout(() => {
        if (this.slideWidth > 0) {
          this.currentIndex = Math.round(this.viewport.scrollLeft / this.slideWidth);
        }
        this.restartAutoplay();
      }, 120);
    }

    goTo(index) {
      const total = this.slides.length;
      if (!total || this.slideWidth <= 0) return;
      this.currentIndex = ((index % total) + total) % total;
      this.viewport.scrollTo({
        left: this.currentIndex * this.slideWidth,
        behavior: 'smooth',
      });
    }

    startAutoplay() {
      if (!this.carouselConnected || !this.autoplay || !this.inViewport || document.hidden || this.slides.length < 2 || this.slideWidth <= 0 || this.timer != null) return;
      this.timer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
    }

    stopAutoplay() {
      clearInterval(this.timer);
      this.timer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  if (!customElements.get('testimonial-carousel')) {
    customElements.define('testimonial-carousel', TestimonialCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  class VideoCarousel extends HTMLElement {
    connectedCallback() {
      if (this.carouselConnected) return;
      this.viewport = this.querySelector('.video-carousel__viewport');
      if (!this.viewport) return;
      this.carouselConnected = true;
      this.slides = Array.from(this.querySelectorAll('.video-carousel__slide'));
      this.prevButton = this.querySelector('.video-carousel__arrow--prev');
      this.nextButton = this.querySelector('.video-carousel__arrow--next');
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 4000;
      this.slideWidth = this.slides[0]?.getBoundingClientRect().width || 0;
      this.currentIndex = this.slideWidth > 0 ? Math.round(this.viewport.scrollLeft / this.slideWidth) : 0;
      this.inViewport = false;

      if (this.slides.length < 2) return;

      this.handleNext = () => this.goTo(this.currentIndex + 1);
      this.handlePrev = () => this.goTo(this.currentIndex - 1);
      this.handleScroll = this.onScroll.bind(this);
      this.handleResize = this.onResize.bind(this);
      this.handleVisibility = this.restartAutoplay.bind(this);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.prevButton?.addEventListener('click', this.handlePrev);
      this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });

      if (!this.autoplay) return;
      document.addEventListener('visibilitychange', this.handleVisibility);
      // Sin observer, las flechas y el gesto manual siguen disponibles.
      if (!('IntersectionObserver' in window)) return;
      try {
        const observer = new IntersectionObserver((entries) => {
          if (!this.carouselConnected || this.visibilityObserver !== observer) return;
          entries.forEach((entry) => {
            if (entry.target !== this) return;
            this.inViewport = entry.isIntersecting && entry.intersectionRatio > 0;
            this.restartAutoplay();
          });
        }, { threshold: [0, 0.001] });
        this.visibilityObserver = observer;
        observer.observe(this);
      } catch (error) {
        this.visibilityObserver?.disconnect();
        this.visibilityObserver = null;
        this.inViewport = false;
        this.stopAutoplay();
      }
    }

    disconnectedCallback() {
      this.carouselConnected = false;
      this.inViewport = false;
      this.stopAutoplay();
      clearTimeout(this.scrollDebounce);
      clearTimeout(this.resizeDebounce);
      this.visibilityObserver?.disconnect();
      this.visibilityObserver = null;
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.prevButton?.removeEventListener('click', this.handlePrev);
      this.viewport?.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('visibilitychange', this.handleVisibility);
    }

    onResize() {
      clearTimeout(this.resizeDebounce);
      this.resizeDebounce = setTimeout(() => {
        this.slideWidth = this.slides[0]?.getBoundingClientRect().width || 0;
        this.restartAutoplay();
      }, 150);
    }

    onScroll() {
      clearTimeout(this.scrollDebounce);
      this.scrollDebounce = setTimeout(() => {
        if (this.slideWidth > 0) {
          this.currentIndex = Math.round(this.viewport.scrollLeft / this.slideWidth);
        }
        this.pauseOtherVideos();
        this.restartAutoplay();
      }, 120);
    }

    goTo(index) {
      const total = this.slides.length;
      if (!total || this.slideWidth <= 0) return;
      this.currentIndex = ((index % total) + total) % total;
      this.viewport.scrollTo({
        left: this.currentIndex * this.slideWidth,
        behavior: 'smooth',
      });
      this.pauseOtherVideos();
    }

    pauseOtherVideos() {
      this.slides.forEach((slide, index) => {
        if (index === this.currentIndex) return;
        slide.querySelectorAll('video').forEach((video) => video.pause());
      });
    }

    startAutoplay() {
      if (!this.carouselConnected || !this.autoplay || !this.inViewport || document.hidden || this.slides.length < 2 || this.slideWidth <= 0 || this.timer != null) return;
      this.timer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
    }

    stopAutoplay() {
      clearInterval(this.timer);
      this.timer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  if (!customElements.get('video-carousel')) {
    customElements.define('video-carousel', VideoCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
